/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleWeight
 */
export interface VehicleWeight {
    /**
     * 
     * @type {Date}
     * @memberof VehicleWeight
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof VehicleWeight
     */
    weight: number;
}

export function VehicleWeightFromJSON(json: any): VehicleWeight {
    return VehicleWeightFromJSONTyped(json, false);
}

export function VehicleWeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleWeight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'weight': json['weight'],
    };
}

export function VehicleWeightToJSON(value?: VehicleWeight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'weight': value.weight,
    };
}


